// AppConfirmDialog.jsx

// import { useRef } from "react";
import { ConfirmDialog } from "primereact/confirmdialog";
import { Button } from "primereact/button";
import { getAppConfirmMeta, clearAppConfirmMeta } from "./appConfirm";

export default function AppConfirmDialog({ group = "appConfirm" }) {
  // const lastMetaRef = useRef({});
  return (
    <ConfirmDialog
      group={group}
      dismissableMask
      content={({
        headerRef,
        contentRef,
        footerRef,
        hide,
        message,
        accept,
        reject,
      }) => {
        const meta = getAppConfirmMeta(group);

        // ✅ keep last meta while dialog is animating out
        // const hasMeta = meta && Object.keys(meta).length > 0;
        // if (hasMeta) lastMetaRef.current = meta;
        // const effectiveMeta = hasMeta ? meta : lastMetaRef.current;
        // const scheme = effectiveMeta.scheme || "neutral";
        // const iconClass = effectiveMeta.icon || "bi bi-exclamation-triangle";
        // const confirmText = effectiveMeta.acceptLabel || "Confirm";
        // const rejectText = effectiveMeta.rejectLabel || "Cancel";

        const scheme = meta.scheme || "neutral";
        const iconClass = meta.icon || "bi bi-exclamation-triangle";
        const confirmText = meta.acceptLabel;
        const rejectText = meta.rejectLabel;

        return (
          <div className={`appConfirmCard appConfirm--${scheme}`}>
            <div className="appConfirmIcon">
              <i className={iconClass} aria-hidden="true" />
            </div>

            <span className="appConfirmTitle" ref={headerRef}>
              {message.header}
            </span>

            <p className="appConfirmText" ref={contentRef}>
              {message.message}
            </p>

            <div className="appConfirmActions" ref={footerRef}>
              <Button
                // label={message.acceptLabel || "Confirm"}
                label={confirmText}
                className="appConfirmBtn appConfirmBtnPrimary"
                onClick={(e) => {
                  hide(e);
                  meta.onAccept?.();
                  // options.accept();
                  // message.accept?.();
                  // clearAppConfirmMeta(group);
                }}
              />
              <Button
                label={rejectText}
                className="appConfirmBtn appConfirmBtnSecondary"
                onClick={(e) => {
                  hide(e);
                  meta.onReject?.();
                  // options.reject();
                  // message.reject?.();
                  // clearAppConfirmMeta(group);
                }}
              />
            </div>
          </div>
        );
      }}
    />
  );
}
